/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * SsoProviderDtoBase
 * auto generated base class for the model SsoProviderDtoModel.
 */
export const SsoProviderDtoModelBase = ModelBase
  .named('SsoProviderDto')
  .props({
    __typename: types.optional(types.literal("SsoProviderDto"), "SsoProviderDto"),
    id: types.identifier,
    name: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SsoProviderDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get name() { return this.__attr(`name`) }
}
export function selectFromSsoProviderDto() {
  return new SsoProviderDtoModelSelector()
}

export const ssoProviderDtoModelPrimitives = selectFromSsoProviderDto().name
